import { render, staticRenderFns } from "./create-algo-data-details.html?vue&type=template&id=1399dbd2&scoped=true&external"
import script from "./create-algo-data-details.js?vue&type=script&lang=js&external"
export * from "./create-algo-data-details.js?vue&type=script&lang=js&external"
import style0 from "./create-algo-data-details.scss?vue&type=style&index=0&id=1399dbd2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399dbd2",
  null
  
)

export default component.exports